import React, {ReactNode} from 'react'
import styles from './UIGameCount.module.scss'
import clsx from 'clsx'
import {PlayerColor} from '@colonist/game-states'
import {getPlayerColorHex} from '../../utils/gameColors'

export interface UIGameCountProps {
    className?: string
    count: ReactNode
    color: PlayerColor
}

export function UIGameCount({
    className,
    count,
    color,
}: UIGameCountProps) {
    const backgroundColor = getPlayerColorHex(color)

    return <div className={clsx(styles.container, className)} style={{backgroundColor: backgroundColor}}>
        <div className={styles.count}>{count}</div>
    </div>
}
